import { H_REFERENCIAL_TAXON } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import TaxonAction from '../actions/TaxonAction'
import { Box } from '@mui/material'


const TaxonRouterApp = () => {
    const dispatch = useDispatch()
    const { code } = useParams()


    const {
        taxons,
    } = useSelector(store => ({
        taxons: store.TaxonReducer.taxons,
    }), shallowEqual)

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.taxon}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_TAXON,
        }, {
            icons: 'map',
            name: i18n.cartography,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.taxon}/${code}/map`,
            habilitation: H_REFERENCIAL_TAXON,
        }, {
            icons: 'perm_media',
            name: i18n.picturesAndDocuments,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.taxon}/${code}/picture`,
            habilitation: H_REFERENCIAL_TAXON,
        }, {
            icons: 'biotech',
            name: i18n.ecoFriendlyFeatures,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.taxon}/${code}/ecoFriendlyFeatures`,
            habilitation: H_REFERENCIAL_TAXON,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code])

    useEffect(() => {
        if (!taxons.length) {
            dispatch(TaxonAction.fetchTaxons())
        }
        if (code !== 'new') {
            dispatch(TaxonAction.fetchTaxon(code))
        }
    }, [dispatch, code])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default TaxonRouterApp